import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { CopyLinkInput, Label, Alert } from '@americanexpress/dls-react';
import { parseHtml } from '../../utils/util';
import { stringconstants } from '../../constants';

const getVal = require('lodash/get');
/**
 * returns DLS input component
 * @param {*} props
 */
/* eslint complexity: ["error", 30] -- need to increase complexity */
const CopyLink = (props) => {
  const {
    fieldLabel,
    fieldId,
    fieldValue,
    formSubmissionPayload,
    cssProperties,
    timeout,
    isPrefilled,
    selectKey,
    prefilledWith,
  } = props;
  const [value, setValue] = useState(fieldValue);
  const [controlledStatus, setControlledStatus] = React.useState(null);

  const handleSuccess = () => {
    setControlledStatus('success');
  };
  const handleError = () => {
    setControlledStatus('error');
  };
  const handleTimeout = () => {
    setControlledStatus(null);
  };
  useEffect(() => {
    if (isPrefilled) {
      if (
        prefilledWith === stringconstants.filledFormData
        && formSubmissionPayload
      ) {
        const preFilledVal = getVal(formSubmissionPayload, selectKey) ? getVal(formSubmissionPayload, selectKey) : '';
        setValue(preFilledVal);
      }
    }
  }, [formSubmissionPayload]);

  return (
    <>
      <Label
        htmlFor={`copyLink-${fieldId}`}
        className={fieldLabel.cssProperties.style}
      >
        {parseHtml(fieldLabel.label)}
      </Label>
      {fieldLabel && fieldLabel.subLabel && (
        <div>
          <label
            className={fieldLabel.cssProperties.subLabelStyle}
            htmlFor={fieldId}
          >
            {parseHtml(fieldLabel.subLabel)}
          </label>
        </div>
      )}
      <CopyLinkInput
        id={fieldId}
        buttonText={fieldLabel.buttonLabel}
        value={value}
        status={controlledStatus}
        timeout={timeout}
        successText={fieldLabel.successText}
        errorText={fieldLabel.errorText}
        styleType={cssProperties.linkInputStyle}
        onSuccess={handleSuccess}
        onError={handleError}
        onTimeout={handleTimeout}
      />
      {controlledStatus === 'success' && (
        <Alert id="copy-link-primary-success-alert" status={controlledStatus}>
          {fieldLabel.successText}
        </Alert>
      )}
      {controlledStatus === 'error' && (
        <Alert id="copy-link-primary-error-alert" status={controlledStatus}>
          {fieldLabel.errorText}
        </Alert>
      )}
    </>
  );
};

CopyLink.propTypes = {
  fieldLabel: PropTypes.objectOf(PropTypes.shape),
  fieldValue: PropTypes.string,
  fieldId: PropTypes.string,
  formSubmissionPayload: PropTypes.objectOf(PropTypes.shape),
  cssProperties: PropTypes.objectOf(PropTypes.shape),
  timeout: PropTypes.string,
  isPrefilled: PropTypes.bool,
  selectKey: PropTypes.string,
  prefilledWith: PropTypes.string,
};

export default CopyLink;
